// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.top-countries{
    font-size: 14px;
    text-align: left;
    padding: 0px 10px;
}

.map-selected {
    fill: #E3DA37;
}
  
.map-unselected {
    fill: #699EAA;
}

.map-selected:hover, .map-unselected:hover {
    cursor: pointer;
}

.countryStats{
    padding: 15px;
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(30%, 1fr));
    text-align: center;
}

.country{
    padding: 20px 0px;
    background-color: #343434;
    border-radius: 10px;
}

.svgMap-wrapper {
    width: 100%;
    height: 100%;
}

.svgMap-map-wrapper {
    width: 100%;
    min-height: 355px;
    height: 100%;
    background-color: transparent;
}

.svgMap-map-container, .svgMap-container{
    height: 100%;
}

/* Let tooltip newlines (\\n) create line breaks */
.svgMap-tooltip,
.svgMap-tooltip-content,
.svgMap-tooltip table {
    white-space: pre-line;
}

@media screen and (max-width: 768px) {
    .svgMap-map-wrapper {
        width: 100%;
        height: 100%;
    }

    .top-countries .grid-container {
        display: grid;
    }
}

/* ========== World map layout (dashboard) ========== */

.world-map {
    display: grid;
    grid-template-columns: 1fr minmax(260px, 300px);
    gap: 20px;
    align-items: stretch;
    width: 100%;
    min-height: 0;
}

.world-map--empty {
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 200px;
    padding: 32px;
    border-radius: 14px;
    border: 1px solid rgba(255, 255, 255, 0.08);
    background: rgba(0, 0, 0, 0.2);
}

.world-map__empty-msg {
    margin: 0;
    font-size: 0.95rem;
    color: rgba(255, 255, 255, 0.45);
    text-align: center;
}

.world-map__main {
    display: flex;
    flex-direction: column;
    min-width: 0;
    border-radius: 14px;
    border: 1px solid rgba(255, 255, 255, 0.08);
    background: linear-gradient(
        165deg,
        rgba(52, 52, 52, 0.5) 0%,
        rgba(34, 34, 34, 0.65) 100%
    );
    box-shadow: 0 8px 28px rgba(0, 0, 0, 0.22);
    overflow: hidden;
}

.world-map__main::before {
    content: "";
    display: block;
    height: 3px;
    background: linear-gradient(
        90deg,
        rgba(192, 159, 83, 0.25),
        rgba(192, 159, 83, 0.85),
        rgba(192, 159, 83, 0.25)
    );
}

.world-map__header {
    padding: 16px 20px 12px;
    text-align: left;
}

.world-map__title {
    margin: 0;
    font-size: 1.05rem;
    font-weight: 600;
    color: rgb(240, 240, 240);
    letter-spacing: -0.02em;
}

.world-map__subtitle {
    margin: 6px 0 0 0;
    font-size: 0.8rem;
    line-height: 1.45;
    color: rgba(255, 255, 255, 0.42);
    max-width: 42rem;
}

.world-map__map-shell {
    flex: 1;
    min-height: 360px;
    padding: 0 8px 12px;
}

.world-map__map-inner {
    width: 100%;
    height: 100%;
    min-height: 340px;
    border-radius: 10px;
    overflow: hidden;
    background: rgba(0, 0, 0, 0.12);
}

.world-map__side {
    display: flex;
    flex-direction: column;
    min-width: 0;
    border-radius: 14px;
    border: 1px solid rgba(255, 255, 255, 0.08);
    background: linear-gradient(180deg, rgba(48, 48, 48, 0.75) 0%, rgba(32, 32, 32, 0.9) 100%);
    box-shadow: 0 8px 28px rgba(0, 0, 0, 0.2);
    overflow: hidden;
}

.world-map__side-head {
    padding: 14px 16px 10px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.06);
}

.world-map__side-title {
    margin: 0;
    font-size: 0.82rem;
    font-weight: 600;
    letter-spacing: 0.1em;
    text-transform: uppercase;
    color: rgba(255, 255, 255, 0.5);
}

.world-map__side-hint {
    margin: 6px 0 0 0;
    font-size: 0.72rem;
    color: rgba(255, 255, 255, 0.35);
}

.world-map__list-scroll {
    flex: 1;
    overflow-y: auto;
    padding: 8px 10px 12px;
    min-height: 200px;
    max-height: 420px;
}

.world-map__row {
    display: flex;
    align-items: stretch;
    gap: 10px;
    width: 100%;
    margin: 0 0 8px 0;
    padding: 8px 10px;
    border: 1px solid rgba(255, 255, 255, 0.06);
    border-radius: 10px;
    background: rgba(0, 0, 0, 0.18);
    color: inherit;
    font: inherit;
    text-align: left;
    cursor: pointer;
    transition: border-color 0.2s ease, background 0.2s ease;
}

.world-map__row:hover:not(:disabled) {
    border-color: rgba(192, 159, 83, 0.35);
    background: rgba(192, 159, 83, 0.06);
}

.world-map__row:disabled {
    opacity: 0.45;
    cursor: default;
}

.world-map__row:focus-visible {
    outline: 2px solid rgba(192, 159, 83, 0.7);
    outline-offset: 2px;
}

.world-map__row-rank {
    flex-shrink: 0;
    width: 26px;
    height: 26px;
    margin-top: 2px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 0.72rem;
    font-weight: 700;
    color: rgba(255, 255, 255, 0.5);
    background: rgba(255, 255, 255, 0.06);
    border-radius: 8px;
}

.world-map__row-body {
    flex: 1;
    min-width: 0;
}

.world-map__row-top {
    display: flex;
    justify-content: space-between;
    align-items: baseline;
    gap: 8px;
}

.world-map__row-name {
    font-size: 0.85rem;
    font-weight: 600;
    color: rgba(255, 255, 255, 0.9);
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.world-map__row-val {
    flex-shrink: 0;
    font-size: 0.82rem;
    font-weight: 600;
    font-variant-numeric: tabular-nums;
    color: rgba(192, 159, 83, 0.95);
    text-align: right;
}

.world-map__row-cmp {
    display: inline-block;
    margin-left: 6px;
    font-size: 0.68rem;
    font-weight: 600;
    color: rgba(140, 200, 235, 0.92);
    vertical-align: middle;
}

.world-map__row-bar {
    margin-top: 6px;
    height: 4px;
    border-radius: 999px;
    background: rgba(255, 255, 255, 0.08);
    overflow: hidden;
}

.world-map__row-bar-fill {
    height: 100%;
    border-radius: 999px;
    background: linear-gradient(90deg, rgba(192, 159, 83, 0.35), rgba(218, 190, 120, 0.95));
    transition: width 0.35s ease;
}

@media screen and (max-width: 960px) {
    .world-map {
        grid-template-columns: 1fr;
    }

    .world-map__list-scroll {
        max-height: 260px;
    }

    .world-map__map-shell {
        min-height: 300px;
    }

    .world-map__map-inner {
        min-height: 280px;
    }
}

/* ========== Country detail drawer ========== */

.world-map-drawer-backdrop {
    position: fixed;
    inset: 0;
    z-index: 198;
    background: rgba(0, 0, 0, 0.55);
    animation: world-map-fade-in 0.2s ease;
}

.world-map-drawer {
    position: fixed;
    top: 0;
    right: 0;
    z-index: 199;
    width: min(420px, 100vw - 16px);
    max-width: 100%;
    height: 100vh;
    height: 100dvh;
    display: flex;
    flex-direction: column;
    padding: 0;
    margin: 0;
    border: none;
    border-left: 1px solid rgba(255, 255, 255, 0.1);
    border-radius: 14px 0 0 14px;
    background: linear-gradient(180deg, rgba(44, 44, 44, 0.98) 0%, rgba(26, 26, 26, 1) 100%);
    box-shadow: -12px 0 48px rgba(0, 0, 0, 0.45);
    animation: world-map-slide-in 0.28s cubic-bezier(0.4, 0, 0.2, 1);
    overflow: hidden;
}

@keyframes world-map-fade-in {
    from {
        opacity: 0;
    }
    to {
        opacity: 1;
    }
}

@keyframes world-map-slide-in {
    from {
        transform: translateX(100%);
        opacity: 0.85;
    }
    to {
        transform: translateX(0);
        opacity: 1;
    }
}

.world-map-drawer__header {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 12px;
    padding: 18px 18px 14px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.08);
    flex-shrink: 0;
}

.world-map-drawer__title-wrap {
    min-width: 0;
}

.world-map-drawer__title {
    margin: 0;
    font-size: 1.2rem;
    font-weight: 600;
    color: rgb(245, 245, 245);
    line-height: 1.25;
    word-break: break-word;
}

.world-map-drawer__iso {
    display: inline-block;
    margin-top: 6px;
    padding: 2px 8px;
    font-size: 0.65rem;
    font-weight: 700;
    letter-spacing: 0.12em;
    color: rgba(255, 255, 255, 0.45);
    background: rgba(255, 255, 255, 0.06);
    border-radius: 6px;
}

.world-map-drawer__close {
    flex-shrink: 0;
    width: 40px;
    height: 40px;
    margin: 0;
    padding: 0;
    border: none;
    border-radius: 10px;
    background: rgba(255, 255, 255, 0.06);
    color: rgba(255, 255, 255, 0.85);
    font-size: 26px;
    line-height: 1;
    cursor: pointer;
    transition: background 0.2s ease;
}

.world-map-drawer__close:hover {
    background: rgba(255, 255, 255, 0.12);
}

.world-map-drawer__share {
    padding: 14px 18px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.06);
    flex-shrink: 0;
}

.world-map-drawer__share-label {
    display: block;
    font-size: 0.62rem;
    font-weight: 600;
    letter-spacing: 0.12em;
    text-transform: uppercase;
    color: rgba(255, 255, 255, 0.38);
    margin-bottom: 8px;
}

.world-map-drawer__share-bar {
    height: 8px;
    border-radius: 999px;
    background: rgba(255, 255, 255, 0.08);
    overflow: hidden;
}

.world-map-drawer__share-fill {
    height: 100%;
    border-radius: 999px;
    background: linear-gradient(90deg, rgba(192, 159, 83, 0.4), rgba(218, 190, 120, 0.95));
    transition: width 0.4s ease;
}

.world-map-drawer__share-pct {
    display: block;
    margin-top: 6px;
    font-size: 0.8rem;
    font-weight: 600;
    color: rgba(192, 159, 83, 0.9);
    font-variant-numeric: tabular-nums;
}

.world-map-drawer__empty {
    margin: 0;
    padding: 20px 18px;
    font-size: 0.88rem;
    line-height: 1.5;
    color: rgba(255, 255, 255, 0.45);
}

.world-map-drawer__stats {
    list-style: none;
    margin: 0;
    padding: 12px 18px 20px;
    overflow-y: auto;
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 10px;
}

.world-map-drawer__stat {
    padding: 12px 14px;
    border-radius: 10px;
    background: rgba(0, 0, 0, 0.22);
    border: 1px solid rgba(255, 255, 255, 0.06);
}

.world-map-drawer__stat-top {
    display: flex;
    align-items: baseline;
    justify-content: space-between;
    gap: 12px;
}

.world-map-drawer__stat-label {
    font-size: 0.68rem;
    font-weight: 600;
    letter-spacing: 0.08em;
    text-transform: uppercase;
    color: rgba(255, 255, 255, 0.4);
}

.world-map-drawer__stat-value {
    font-size: 1rem;
    font-weight: 700;
    font-variant-numeric: tabular-nums;
    color: rgb(240, 240, 240);
    flex-shrink: 0;
}

.world-map-drawer__stat-sub {
    display: block;
    margin-top: 6px;
    font-size: 0.75rem;
    color: rgba(255, 255, 255, 0.45);
    font-variant-numeric: tabular-nums;
}

.world-map-drawer__stat-cmp {
    display: block;
    margin-top: 6px;
    font-size: 0.72rem;
    line-height: 1.4;
    color: rgba(150, 200, 235, 0.9);
    font-variant-numeric: tabular-nums;
}

.world-map-drawer__extras {
    flex-shrink: 0;
    padding: 0 18px 22px;
    border-top: 1px solid rgba(255, 255, 255, 0.08);
    max-height: min(55vh, 480px);
    overflow-y: auto;
}

.world-map-drawer__extras-title {
    margin: 0;
    padding: 16px 0 10px;
    font-size: 0.65rem;
    font-weight: 600;
    letter-spacing: 0.14em;
    text-transform: uppercase;
    color: rgba(255, 255, 255, 0.38);
}

.world-map-drawer__embed {
    border-radius: 12px;
    overflow: hidden;
}

.world-map-drawer__embed .device-interactions {
    margin: 0;
    box-shadow: none;
}

.world-map-drawer__embed .device-interactions::before {
    height: 2px;
}

.world-map-drawer__cta {
    flex-shrink: 0;
    padding: 14px 18px 18px;
    border-top: 1px solid rgba(255, 255, 255, 0.08);
}

.world-map-drawer__cta-link {
    position: relative;
    display: grid;
    grid-template-columns: 1fr auto;
    grid-template-rows: auto auto;
    gap: 2px 12px;
    align-items: center;
    padding: 12px 14px;
    border-radius: 12px;
    background: linear-gradient(135deg, rgba(192, 159, 83, 0.18), rgba(192, 159, 83, 0.06));
    border: 1px solid rgba(192, 159, 83, 0.35);
    color: #f5e6c5;
    text-decoration: none;
    transition: background 0.15s ease, border-color 0.15s ease, transform 0.15s ease;
}

.world-map-drawer__cta-link:hover,
.world-map-drawer__cta-link:focus-visible {
    background: linear-gradient(135deg, rgba(192, 159, 83, 0.28), rgba(192, 159, 83, 0.1));
    border-color: rgba(192, 159, 83, 0.6);
    transform: translateY(-1px);
    outline: none;
}

.world-map-drawer__cta-label {
    grid-column: 1;
    grid-row: 1;
    font-size: 0.9rem;
    font-weight: 600;
    color: #fff;
    letter-spacing: 0.01em;
}

.world-map-drawer__cta-sub {
    grid-column: 1;
    grid-row: 2;
    font-size: 0.75rem;
    color: rgba(255, 255, 255, 0.62);
    line-height: 1.35;
}

.world-map-drawer__cta-arrow {
    grid-column: 2;
    grid-row: 1 / span 2;
    font-size: 1.15rem;
    font-weight: 600;
    color: #c09f53;
}

@media screen and (max-width: 480px) {
    .world-map-drawer {
        width: 100vw;
        border-radius: 0;
    }
}

/* Suppress svgMap tooltip in data-flow mode */
.world-map--flow .svgMap-tooltip {
    display: none !important;
}

/* ── Data flow legend ────────────────────────────────────────────────────────── */
.world-map__legend {
    display: flex;
    align-items: center;
    gap: 7px;
    margin-top: 8px;
    flex-wrap: wrap;
}

.world-map__legend-swatch {
    flex-shrink: 0;
    width: 18px;
    height: 10px;
    border-radius: 2px;
}

.world-map__legend-swatch--flow {
    background: rgba(220, 80, 80, 0.15);
    border: 1.5px solid rgba(220, 80, 80, 0.7);
}

.world-map__legend-swatch--origin {
    background: rgba(80, 168, 120, 0.2);
    border: 1.5px solid rgba(80, 168, 120, 0.8);
    border-radius: 50%;
    width: 10px;
    height: 10px;
}

.world-map__legend-sep {
    width: 1px;
    height: 12px;
    background: rgba(255, 255, 255, 0.12);
    margin: 0 2px;
}

.world-map__legend-label {
    font-size: 0.68rem;
    color: rgba(255, 255, 255, 0.38);
    letter-spacing: 0.02em;
}

/* ── Data flow SVG overlay ────────────────────────────────────────────────────── */
@keyframes flow-arc-draw {
    from { stroke-dashoffset: var(--arc-len, 600); }
    to   { stroke-dashoffset: 0; }
}

@keyframes flow-origin-pulse {
    0%, 100% { r: 6; opacity: 0.5; }
    50%       { r: 10; opacity: 0.1; }
}

.flow-arc {
    stroke: rgba(220, 80, 80, 0.5);
    stroke-width: 1.3;
    fill: none;
    stroke-dasharray: 600;
    stroke-dashoffset: 600;
    animation: flow-arc-draw 1.2s ease forwards;
}

.flow-dot {
    fill: rgba(220, 80, 80, 0.9);
    filter: drop-shadow(0 0 2px rgba(220, 80, 80, 0.6));
}

.flow-origin-ring {
    fill: rgba(80, 168, 120, 0.15);
    stroke: rgba(80, 168, 120, 0.8);
    stroke-width: 1.5;
    animation: flow-origin-pulse 2.4s ease-in-out infinite;
}

.flow-origin-dot {
    fill: #50a878;
    filter: drop-shadow(0 0 3px rgba(80, 168, 120, 0.7));
}

.flow-dest-ring {
    fill: rgba(220, 80, 80, 0.12);
    stroke: rgba(220, 80, 80, 0.6);
    stroke-width: 1.2;
}

.flow-dest-dot {
    fill: rgba(220, 80, 80, 0.85);
    filter: drop-shadow(0 0 2px rgba(220, 80, 80, 0.5));
}`, "",{"version":3,"sources":["webpack://./src/Components/Charts/WorldMap/Style.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,aAAa;IACb,yDAAyD;IACzD,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,iBAAiB;IACjB,YAAY;IACZ,6BAA6B;AACjC;;AAEA;IACI,YAAY;AAChB;;AAEA,iDAAiD;AACjD;;;IAGI,qBAAqB;AACzB;;AAEA;IACI;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,aAAa;IACjB;AACJ;;AAEA,uDAAuD;;AAEvD;IACI,aAAa;IACb,+CAA+C;IAC/C,SAAS;IACT,oBAAoB;IACpB,WAAW;IACX,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,2CAA2C;IAC3C,8BAA8B;AAClC;;AAEA;IACI,SAAS;IACT,kBAAkB;IAClB,gCAAgC;IAChC,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,mBAAmB;IACnB,2CAA2C;IAC3C;;;;KAIC;IACD,0CAA0C;IAC1C,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,cAAc;IACd,WAAW;IACX;;;;;KAKC;AACL;;AAEA;IACI,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;IACI,SAAS;IACT,kBAAkB;IAClB,gBAAgB;IAChB,yBAAyB;IACzB,uBAAuB;AAC3B;;AAEA;IACI,iBAAiB;IACjB,iBAAiB;IACjB,iBAAiB;IACjB,gCAAgC;IAChC,gBAAgB;AACpB;;AAEA;IACI,OAAO;IACP,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,mBAAmB;IACnB,gBAAgB;IAChB,+BAA+B;AACnC;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,mBAAmB;IACnB,2CAA2C;IAC3C,0FAA0F;IAC1F,yCAAyC;IACzC,gBAAgB;AACpB;;AAEA;IACI,uBAAuB;IACvB,kDAAkD;AACtD;;AAEA;IACI,SAAS;IACT,kBAAkB;IAClB,gBAAgB;IAChB,qBAAqB;IACrB,yBAAyB;IACzB,+BAA+B;AACnC;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,gCAAgC;AACpC;;AAEA;IACI,OAAO;IACP,gBAAgB;IAChB,sBAAsB;IACtB,iBAAiB;IACjB,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,oBAAoB;IACpB,SAAS;IACT,WAAW;IACX,iBAAiB;IACjB,iBAAiB;IACjB,2CAA2C;IAC3C,mBAAmB;IACnB,+BAA+B;IAC/B,cAAc;IACd,aAAa;IACb,gBAAgB;IAChB,eAAe;IACf,wDAAwD;AAC5D;;AAEA;IACI,sCAAsC;IACtC,oCAAoC;AACxC;;AAEA;IACI,aAAa;IACb,eAAe;AACnB;;AAEA;IACI,0CAA0C;IAC1C,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,WAAW;IACX,YAAY;IACZ,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,gBAAgB;IAChB,+BAA+B;IAC/B,qCAAqC;IACrC,kBAAkB;AACtB;;AAEA;IACI,OAAO;IACP,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,qBAAqB;IACrB,QAAQ;AACZ;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,+BAA+B;IAC/B,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,gBAAgB;IAChB,kCAAkC;IAClC,+BAA+B;IAC/B,iBAAiB;AACrB;;AAEA;IACI,qBAAqB;IACrB,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;IAChB,gCAAgC;IAChC,sBAAsB;AAC1B;;AAEA;IACI,eAAe;IACf,WAAW;IACX,oBAAoB;IACpB,qCAAqC;IACrC,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,oBAAoB;IACpB,uFAAuF;IACvF,4BAA4B;AAChC;;AAEA;IACI;QACI,0BAA0B;IAC9B;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,iBAAiB;IACrB;AACJ;;AAEA,gDAAgD;;AAEhD;IACI,eAAe;IACf,QAAQ;IACR,YAAY;IACZ,+BAA+B;IAC/B,sCAAsC;AAC1C;;AAEA;IACI,eAAe;IACf,MAAM;IACN,QAAQ;IACR,YAAY;IACZ,+BAA+B;IAC/B,eAAe;IACf,aAAa;IACb,cAAc;IACd,aAAa;IACb,sBAAsB;IACtB,UAAU;IACV,SAAS;IACT,YAAY;IACZ,+CAA+C;IAC/C,4BAA4B;IAC5B,wFAAwF;IACxF,4CAA4C;IAC5C,gEAAgE;IAChE,gBAAgB;AACpB;;AAEA;IACI;QACI,UAAU;IACd;IACA;QACI,UAAU;IACd;AACJ;;AAEA;IACI;QACI,2BAA2B;QAC3B,aAAa;IACjB;IACA;QACI,wBAAwB;QACxB,UAAU;IACd;AACJ;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,8BAA8B;IAC9B,SAAS;IACT,uBAAuB;IACvB,kDAAkD;IAClD,cAAc;AAClB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,SAAS;IACT,iBAAiB;IACjB,gBAAgB;IAChB,yBAAyB;IACzB,iBAAiB;IACjB,sBAAsB;AAC1B;;AAEA;IACI,qBAAqB;IACrB,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;IAChB,sBAAsB;IACtB,gCAAgC;IAChC,qCAAqC;IACrC,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,WAAW;IACX,YAAY;IACZ,SAAS;IACT,UAAU;IACV,YAAY;IACZ,mBAAmB;IACnB,qCAAqC;IACrC,gCAAgC;IAChC,eAAe;IACf,cAAc;IACd,eAAe;IACf,gCAAgC;AACpC;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,kBAAkB;IAClB,kDAAkD;IAClD,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;IACzB,gCAAgC;IAChC,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,oBAAoB;IACpB,qCAAqC;IACrC,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,oBAAoB;IACpB,sFAAsF;IACtF,2BAA2B;AAC/B;;AAEA;IACI,cAAc;IACd,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,8BAA8B;IAC9B,kCAAkC;AACtC;;AAEA;IACI,SAAS;IACT,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,gCAAgC;AACpC;;AAEA;IACI,gBAAgB;IAChB,SAAS;IACT,uBAAuB;IACvB,gBAAgB;IAChB,OAAO;IACP,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,+BAA+B;IAC/B,2CAA2C;AAC/C;;AAEA;IACI,aAAa;IACb,qBAAqB;IACrB,8BAA8B;IAC9B,SAAS;AACb;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;IACzB,+BAA+B;AACnC;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,kCAAkC;IAClC,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,kBAAkB;IAClB,gCAAgC;IAChC,kCAAkC;AACtC;;AAEA;IACI,cAAc;IACd,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,+BAA+B;IAC/B,kCAAkC;AACtC;;AAEA;IACI,cAAc;IACd,oBAAoB;IACpB,+CAA+C;IAC/C,4BAA4B;IAC5B,gBAAgB;AACpB;;AAEA;IACI,SAAS;IACT,oBAAoB;IACpB,kBAAkB;IAClB,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;IACzB,gCAAgC;AACpC;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,cAAc;IACd,uBAAuB;IACvB,+CAA+C;AACnD;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,+BAA+B;IAC/B,6BAA6B;IAC7B,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,mBAAmB;IACnB,uFAAuF;IACvF,0CAA0C;IAC1C,cAAc;IACd,qBAAqB;IACrB,gFAAgF;AACpF;;AAEA;;IAEI,sFAAsF;IACtF,qCAAqC;IACrC,2BAA2B;IAC3B,aAAa;AACjB;;AAEA;IACI,cAAc;IACd,WAAW;IACX,iBAAiB;IACjB,gBAAgB;IAChB,WAAW;IACX,sBAAsB;AAC1B;;AAEA;IACI,cAAc;IACd,WAAW;IACX,kBAAkB;IAClB,gCAAgC;IAChC,iBAAiB;AACrB;;AAEA;IACI,cAAc;IACd,oBAAoB;IACpB,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI;QACI,YAAY;QACZ,gBAAgB;IACpB;AACJ;;AAEA,8CAA8C;AAC9C;IACI,wBAAwB;AAC5B;;AAEA,mFAAmF;AACnF;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,WAAW;IACX,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,mCAAmC;IACnC,0CAA0C;AAC9C;;AAEA;IACI,mCAAmC;IACnC,2CAA2C;IAC3C,kBAAkB;IAClB,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,UAAU;IACV,YAAY;IACZ,qCAAqC;IACrC,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,gCAAgC;IAChC,sBAAsB;AAC1B;;AAEA,oFAAoF;AACpF;IACI,OAAO,sCAAsC,EAAE;IAC/C,OAAO,oBAAoB,EAAE;AACjC;;AAEA;IACI,WAAW,IAAI,EAAE,YAAY,EAAE;IAC/B,YAAY,KAAK,EAAE,YAAY,EAAE;AACrC;;AAEA;IACI,8BAA8B;IAC9B,iBAAiB;IACjB,UAAU;IACV,qBAAqB;IACrB,sBAAsB;IACtB,2CAA2C;AAC/C;;AAEA;IACI,4BAA4B;IAC5B,mDAAmD;AACvD;;AAEA;IACI,8BAA8B;IAC9B,+BAA+B;IAC/B,iBAAiB;IACjB,sDAAsD;AAC1D;;AAEA;IACI,aAAa;IACb,oDAAoD;AACxD;;AAEA;IACI,6BAA6B;IAC7B,8BAA8B;IAC9B,iBAAiB;AACrB;;AAEA;IACI,6BAA6B;IAC7B,mDAAmD;AACvD","sourcesContent":[".top-countries{\n    font-size: 14px;\n    text-align: left;\n    padding: 0px 10px;\n}\n\n.map-selected {\n    fill: #E3DA37;\n}\n  \n.map-unselected {\n    fill: #699EAA;\n}\n\n.map-selected:hover, .map-unselected:hover {\n    cursor: pointer;\n}\n\n.countryStats{\n    padding: 15px;\n    display: grid;\n    grid-template-columns: repeat(auto-fit, minmax(30%, 1fr));\n    text-align: center;\n}\n\n.country{\n    padding: 20px 0px;\n    background-color: #343434;\n    border-radius: 10px;\n}\n\n.svgMap-wrapper {\n    width: 100%;\n    height: 100%;\n}\n\n.svgMap-map-wrapper {\n    width: 100%;\n    min-height: 355px;\n    height: 100%;\n    background-color: transparent;\n}\n\n.svgMap-map-container, .svgMap-container{\n    height: 100%;\n}\n\n/* Let tooltip newlines (\\n) create line breaks */\n.svgMap-tooltip,\n.svgMap-tooltip-content,\n.svgMap-tooltip table {\n    white-space: pre-line;\n}\n\n@media screen and (max-width: 768px) {\n    .svgMap-map-wrapper {\n        width: 100%;\n        height: 100%;\n    }\n\n    .top-countries .grid-container {\n        display: grid;\n    }\n}\n\n/* ========== World map layout (dashboard) ========== */\n\n.world-map {\n    display: grid;\n    grid-template-columns: 1fr minmax(260px, 300px);\n    gap: 20px;\n    align-items: stretch;\n    width: 100%;\n    min-height: 0;\n}\n\n.world-map--empty {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    min-height: 200px;\n    padding: 32px;\n    border-radius: 14px;\n    border: 1px solid rgba(255, 255, 255, 0.08);\n    background: rgba(0, 0, 0, 0.2);\n}\n\n.world-map__empty-msg {\n    margin: 0;\n    font-size: 0.95rem;\n    color: rgba(255, 255, 255, 0.45);\n    text-align: center;\n}\n\n.world-map__main {\n    display: flex;\n    flex-direction: column;\n    min-width: 0;\n    border-radius: 14px;\n    border: 1px solid rgba(255, 255, 255, 0.08);\n    background: linear-gradient(\n        165deg,\n        rgba(52, 52, 52, 0.5) 0%,\n        rgba(34, 34, 34, 0.65) 100%\n    );\n    box-shadow: 0 8px 28px rgba(0, 0, 0, 0.22);\n    overflow: hidden;\n}\n\n.world-map__main::before {\n    content: \"\";\n    display: block;\n    height: 3px;\n    background: linear-gradient(\n        90deg,\n        rgba(192, 159, 83, 0.25),\n        rgba(192, 159, 83, 0.85),\n        rgba(192, 159, 83, 0.25)\n    );\n}\n\n.world-map__header {\n    padding: 16px 20px 12px;\n    text-align: left;\n}\n\n.world-map__title {\n    margin: 0;\n    font-size: 1.05rem;\n    font-weight: 600;\n    color: rgb(240, 240, 240);\n    letter-spacing: -0.02em;\n}\n\n.world-map__subtitle {\n    margin: 6px 0 0 0;\n    font-size: 0.8rem;\n    line-height: 1.45;\n    color: rgba(255, 255, 255, 0.42);\n    max-width: 42rem;\n}\n\n.world-map__map-shell {\n    flex: 1;\n    min-height: 360px;\n    padding: 0 8px 12px;\n}\n\n.world-map__map-inner {\n    width: 100%;\n    height: 100%;\n    min-height: 340px;\n    border-radius: 10px;\n    overflow: hidden;\n    background: rgba(0, 0, 0, 0.12);\n}\n\n.world-map__side {\n    display: flex;\n    flex-direction: column;\n    min-width: 0;\n    border-radius: 14px;\n    border: 1px solid rgba(255, 255, 255, 0.08);\n    background: linear-gradient(180deg, rgba(48, 48, 48, 0.75) 0%, rgba(32, 32, 32, 0.9) 100%);\n    box-shadow: 0 8px 28px rgba(0, 0, 0, 0.2);\n    overflow: hidden;\n}\n\n.world-map__side-head {\n    padding: 14px 16px 10px;\n    border-bottom: 1px solid rgba(255, 255, 255, 0.06);\n}\n\n.world-map__side-title {\n    margin: 0;\n    font-size: 0.82rem;\n    font-weight: 600;\n    letter-spacing: 0.1em;\n    text-transform: uppercase;\n    color: rgba(255, 255, 255, 0.5);\n}\n\n.world-map__side-hint {\n    margin: 6px 0 0 0;\n    font-size: 0.72rem;\n    color: rgba(255, 255, 255, 0.35);\n}\n\n.world-map__list-scroll {\n    flex: 1;\n    overflow-y: auto;\n    padding: 8px 10px 12px;\n    min-height: 200px;\n    max-height: 420px;\n}\n\n.world-map__row {\n    display: flex;\n    align-items: stretch;\n    gap: 10px;\n    width: 100%;\n    margin: 0 0 8px 0;\n    padding: 8px 10px;\n    border: 1px solid rgba(255, 255, 255, 0.06);\n    border-radius: 10px;\n    background: rgba(0, 0, 0, 0.18);\n    color: inherit;\n    font: inherit;\n    text-align: left;\n    cursor: pointer;\n    transition: border-color 0.2s ease, background 0.2s ease;\n}\n\n.world-map__row:hover:not(:disabled) {\n    border-color: rgba(192, 159, 83, 0.35);\n    background: rgba(192, 159, 83, 0.06);\n}\n\n.world-map__row:disabled {\n    opacity: 0.45;\n    cursor: default;\n}\n\n.world-map__row:focus-visible {\n    outline: 2px solid rgba(192, 159, 83, 0.7);\n    outline-offset: 2px;\n}\n\n.world-map__row-rank {\n    flex-shrink: 0;\n    width: 26px;\n    height: 26px;\n    margin-top: 2px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 0.72rem;\n    font-weight: 700;\n    color: rgba(255, 255, 255, 0.5);\n    background: rgba(255, 255, 255, 0.06);\n    border-radius: 8px;\n}\n\n.world-map__row-body {\n    flex: 1;\n    min-width: 0;\n}\n\n.world-map__row-top {\n    display: flex;\n    justify-content: space-between;\n    align-items: baseline;\n    gap: 8px;\n}\n\n.world-map__row-name {\n    font-size: 0.85rem;\n    font-weight: 600;\n    color: rgba(255, 255, 255, 0.9);\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n\n.world-map__row-val {\n    flex-shrink: 0;\n    font-size: 0.82rem;\n    font-weight: 600;\n    font-variant-numeric: tabular-nums;\n    color: rgba(192, 159, 83, 0.95);\n    text-align: right;\n}\n\n.world-map__row-cmp {\n    display: inline-block;\n    margin-left: 6px;\n    font-size: 0.68rem;\n    font-weight: 600;\n    color: rgba(140, 200, 235, 0.92);\n    vertical-align: middle;\n}\n\n.world-map__row-bar {\n    margin-top: 6px;\n    height: 4px;\n    border-radius: 999px;\n    background: rgba(255, 255, 255, 0.08);\n    overflow: hidden;\n}\n\n.world-map__row-bar-fill {\n    height: 100%;\n    border-radius: 999px;\n    background: linear-gradient(90deg, rgba(192, 159, 83, 0.35), rgba(218, 190, 120, 0.95));\n    transition: width 0.35s ease;\n}\n\n@media screen and (max-width: 960px) {\n    .world-map {\n        grid-template-columns: 1fr;\n    }\n\n    .world-map__list-scroll {\n        max-height: 260px;\n    }\n\n    .world-map__map-shell {\n        min-height: 300px;\n    }\n\n    .world-map__map-inner {\n        min-height: 280px;\n    }\n}\n\n/* ========== Country detail drawer ========== */\n\n.world-map-drawer-backdrop {\n    position: fixed;\n    inset: 0;\n    z-index: 198;\n    background: rgba(0, 0, 0, 0.55);\n    animation: world-map-fade-in 0.2s ease;\n}\n\n.world-map-drawer {\n    position: fixed;\n    top: 0;\n    right: 0;\n    z-index: 199;\n    width: min(420px, 100vw - 16px);\n    max-width: 100%;\n    height: 100vh;\n    height: 100dvh;\n    display: flex;\n    flex-direction: column;\n    padding: 0;\n    margin: 0;\n    border: none;\n    border-left: 1px solid rgba(255, 255, 255, 0.1);\n    border-radius: 14px 0 0 14px;\n    background: linear-gradient(180deg, rgba(44, 44, 44, 0.98) 0%, rgba(26, 26, 26, 1) 100%);\n    box-shadow: -12px 0 48px rgba(0, 0, 0, 0.45);\n    animation: world-map-slide-in 0.28s cubic-bezier(0.4, 0, 0.2, 1);\n    overflow: hidden;\n}\n\n@keyframes world-map-fade-in {\n    from {\n        opacity: 0;\n    }\n    to {\n        opacity: 1;\n    }\n}\n\n@keyframes world-map-slide-in {\n    from {\n        transform: translateX(100%);\n        opacity: 0.85;\n    }\n    to {\n        transform: translateX(0);\n        opacity: 1;\n    }\n}\n\n.world-map-drawer__header {\n    display: flex;\n    align-items: flex-start;\n    justify-content: space-between;\n    gap: 12px;\n    padding: 18px 18px 14px;\n    border-bottom: 1px solid rgba(255, 255, 255, 0.08);\n    flex-shrink: 0;\n}\n\n.world-map-drawer__title-wrap {\n    min-width: 0;\n}\n\n.world-map-drawer__title {\n    margin: 0;\n    font-size: 1.2rem;\n    font-weight: 600;\n    color: rgb(245, 245, 245);\n    line-height: 1.25;\n    word-break: break-word;\n}\n\n.world-map-drawer__iso {\n    display: inline-block;\n    margin-top: 6px;\n    padding: 2px 8px;\n    font-size: 0.65rem;\n    font-weight: 700;\n    letter-spacing: 0.12em;\n    color: rgba(255, 255, 255, 0.45);\n    background: rgba(255, 255, 255, 0.06);\n    border-radius: 6px;\n}\n\n.world-map-drawer__close {\n    flex-shrink: 0;\n    width: 40px;\n    height: 40px;\n    margin: 0;\n    padding: 0;\n    border: none;\n    border-radius: 10px;\n    background: rgba(255, 255, 255, 0.06);\n    color: rgba(255, 255, 255, 0.85);\n    font-size: 26px;\n    line-height: 1;\n    cursor: pointer;\n    transition: background 0.2s ease;\n}\n\n.world-map-drawer__close:hover {\n    background: rgba(255, 255, 255, 0.12);\n}\n\n.world-map-drawer__share {\n    padding: 14px 18px;\n    border-bottom: 1px solid rgba(255, 255, 255, 0.06);\n    flex-shrink: 0;\n}\n\n.world-map-drawer__share-label {\n    display: block;\n    font-size: 0.62rem;\n    font-weight: 600;\n    letter-spacing: 0.12em;\n    text-transform: uppercase;\n    color: rgba(255, 255, 255, 0.38);\n    margin-bottom: 8px;\n}\n\n.world-map-drawer__share-bar {\n    height: 8px;\n    border-radius: 999px;\n    background: rgba(255, 255, 255, 0.08);\n    overflow: hidden;\n}\n\n.world-map-drawer__share-fill {\n    height: 100%;\n    border-radius: 999px;\n    background: linear-gradient(90deg, rgba(192, 159, 83, 0.4), rgba(218, 190, 120, 0.95));\n    transition: width 0.4s ease;\n}\n\n.world-map-drawer__share-pct {\n    display: block;\n    margin-top: 6px;\n    font-size: 0.8rem;\n    font-weight: 600;\n    color: rgba(192, 159, 83, 0.9);\n    font-variant-numeric: tabular-nums;\n}\n\n.world-map-drawer__empty {\n    margin: 0;\n    padding: 20px 18px;\n    font-size: 0.88rem;\n    line-height: 1.5;\n    color: rgba(255, 255, 255, 0.45);\n}\n\n.world-map-drawer__stats {\n    list-style: none;\n    margin: 0;\n    padding: 12px 18px 20px;\n    overflow-y: auto;\n    flex: 1;\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n}\n\n.world-map-drawer__stat {\n    padding: 12px 14px;\n    border-radius: 10px;\n    background: rgba(0, 0, 0, 0.22);\n    border: 1px solid rgba(255, 255, 255, 0.06);\n}\n\n.world-map-drawer__stat-top {\n    display: flex;\n    align-items: baseline;\n    justify-content: space-between;\n    gap: 12px;\n}\n\n.world-map-drawer__stat-label {\n    font-size: 0.68rem;\n    font-weight: 600;\n    letter-spacing: 0.08em;\n    text-transform: uppercase;\n    color: rgba(255, 255, 255, 0.4);\n}\n\n.world-map-drawer__stat-value {\n    font-size: 1rem;\n    font-weight: 700;\n    font-variant-numeric: tabular-nums;\n    color: rgb(240, 240, 240);\n    flex-shrink: 0;\n}\n\n.world-map-drawer__stat-sub {\n    display: block;\n    margin-top: 6px;\n    font-size: 0.75rem;\n    color: rgba(255, 255, 255, 0.45);\n    font-variant-numeric: tabular-nums;\n}\n\n.world-map-drawer__stat-cmp {\n    display: block;\n    margin-top: 6px;\n    font-size: 0.72rem;\n    line-height: 1.4;\n    color: rgba(150, 200, 235, 0.9);\n    font-variant-numeric: tabular-nums;\n}\n\n.world-map-drawer__extras {\n    flex-shrink: 0;\n    padding: 0 18px 22px;\n    border-top: 1px solid rgba(255, 255, 255, 0.08);\n    max-height: min(55vh, 480px);\n    overflow-y: auto;\n}\n\n.world-map-drawer__extras-title {\n    margin: 0;\n    padding: 16px 0 10px;\n    font-size: 0.65rem;\n    font-weight: 600;\n    letter-spacing: 0.14em;\n    text-transform: uppercase;\n    color: rgba(255, 255, 255, 0.38);\n}\n\n.world-map-drawer__embed {\n    border-radius: 12px;\n    overflow: hidden;\n}\n\n.world-map-drawer__embed .device-interactions {\n    margin: 0;\n    box-shadow: none;\n}\n\n.world-map-drawer__embed .device-interactions::before {\n    height: 2px;\n}\n\n.world-map-drawer__cta {\n    flex-shrink: 0;\n    padding: 14px 18px 18px;\n    border-top: 1px solid rgba(255, 255, 255, 0.08);\n}\n\n.world-map-drawer__cta-link {\n    position: relative;\n    display: grid;\n    grid-template-columns: 1fr auto;\n    grid-template-rows: auto auto;\n    gap: 2px 12px;\n    align-items: center;\n    padding: 12px 14px;\n    border-radius: 12px;\n    background: linear-gradient(135deg, rgba(192, 159, 83, 0.18), rgba(192, 159, 83, 0.06));\n    border: 1px solid rgba(192, 159, 83, 0.35);\n    color: #f5e6c5;\n    text-decoration: none;\n    transition: background 0.15s ease, border-color 0.15s ease, transform 0.15s ease;\n}\n\n.world-map-drawer__cta-link:hover,\n.world-map-drawer__cta-link:focus-visible {\n    background: linear-gradient(135deg, rgba(192, 159, 83, 0.28), rgba(192, 159, 83, 0.1));\n    border-color: rgba(192, 159, 83, 0.6);\n    transform: translateY(-1px);\n    outline: none;\n}\n\n.world-map-drawer__cta-label {\n    grid-column: 1;\n    grid-row: 1;\n    font-size: 0.9rem;\n    font-weight: 600;\n    color: #fff;\n    letter-spacing: 0.01em;\n}\n\n.world-map-drawer__cta-sub {\n    grid-column: 1;\n    grid-row: 2;\n    font-size: 0.75rem;\n    color: rgba(255, 255, 255, 0.62);\n    line-height: 1.35;\n}\n\n.world-map-drawer__cta-arrow {\n    grid-column: 2;\n    grid-row: 1 / span 2;\n    font-size: 1.15rem;\n    font-weight: 600;\n    color: #c09f53;\n}\n\n@media screen and (max-width: 480px) {\n    .world-map-drawer {\n        width: 100vw;\n        border-radius: 0;\n    }\n}\n\n/* Suppress svgMap tooltip in data-flow mode */\n.world-map--flow .svgMap-tooltip {\n    display: none !important;\n}\n\n/* ── Data flow legend ────────────────────────────────────────────────────────── */\n.world-map__legend {\n    display: flex;\n    align-items: center;\n    gap: 7px;\n    margin-top: 8px;\n    flex-wrap: wrap;\n}\n\n.world-map__legend-swatch {\n    flex-shrink: 0;\n    width: 18px;\n    height: 10px;\n    border-radius: 2px;\n}\n\n.world-map__legend-swatch--flow {\n    background: rgba(220, 80, 80, 0.15);\n    border: 1.5px solid rgba(220, 80, 80, 0.7);\n}\n\n.world-map__legend-swatch--origin {\n    background: rgba(80, 168, 120, 0.2);\n    border: 1.5px solid rgba(80, 168, 120, 0.8);\n    border-radius: 50%;\n    width: 10px;\n    height: 10px;\n}\n\n.world-map__legend-sep {\n    width: 1px;\n    height: 12px;\n    background: rgba(255, 255, 255, 0.12);\n    margin: 0 2px;\n}\n\n.world-map__legend-label {\n    font-size: 0.68rem;\n    color: rgba(255, 255, 255, 0.38);\n    letter-spacing: 0.02em;\n}\n\n/* ── Data flow SVG overlay ────────────────────────────────────────────────────── */\n@keyframes flow-arc-draw {\n    from { stroke-dashoffset: var(--arc-len, 600); }\n    to   { stroke-dashoffset: 0; }\n}\n\n@keyframes flow-origin-pulse {\n    0%, 100% { r: 6; opacity: 0.5; }\n    50%       { r: 10; opacity: 0.1; }\n}\n\n.flow-arc {\n    stroke: rgba(220, 80, 80, 0.5);\n    stroke-width: 1.3;\n    fill: none;\n    stroke-dasharray: 600;\n    stroke-dashoffset: 600;\n    animation: flow-arc-draw 1.2s ease forwards;\n}\n\n.flow-dot {\n    fill: rgba(220, 80, 80, 0.9);\n    filter: drop-shadow(0 0 2px rgba(220, 80, 80, 0.6));\n}\n\n.flow-origin-ring {\n    fill: rgba(80, 168, 120, 0.15);\n    stroke: rgba(80, 168, 120, 0.8);\n    stroke-width: 1.5;\n    animation: flow-origin-pulse 2.4s ease-in-out infinite;\n}\n\n.flow-origin-dot {\n    fill: #50a878;\n    filter: drop-shadow(0 0 3px rgba(80, 168, 120, 0.7));\n}\n\n.flow-dest-ring {\n    fill: rgba(220, 80, 80, 0.12);\n    stroke: rgba(220, 80, 80, 0.6);\n    stroke-width: 1.2;\n}\n\n.flow-dest-dot {\n    fill: rgba(220, 80, 80, 0.85);\n    filter: drop-shadow(0 0 2px rgba(220, 80, 80, 0.5));\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
